import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { GridRow, LoadTitle } from "../styles";
import { FormLabel } from "shared/modals/styles";
import { LabelRedStar } from "shared/pages/designerEditView/styles";
import styled from "styled-components";
import { ImagePreviewSectionHolder, ImagePreviewSectionImage, ImagePreviewSectionPlacerButton } from "shared/components/ImagePreviewSection/ImagePreviewSection";
import { Colors, CommonLabel, FlexBox, useBreakpoint, useIsMobile, useScale } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { TFile } from "@brg/api";
import { useUppyLoader, UploadedImage } from "shared/hooks/useUppyLoader";
import useUploadValidator from "shared/hooks/useUploadValidator";
import { LayoutConst } from "core";

const PreformattedText = styled(FlexBox)`
  white-space: break-spaces;
`

const Content = styled.div`
  width: 100%;
  min-height: 594px;

  input {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
    display: block !important;
    min-height: 564px !important;
  }

`


  interface ImageArrayUploadFieldProps {
    label: string;
    required?: boolean;
    onlyJpgFormat?: boolean;
  }
  
  export const CoverField: FC<ImageArrayUploadFieldProps> = ({
    input: { onChange, value: inputValue },
    meta: { touched, error },
    label,
    required,
    onlyJpgFormat,
    ...rest
  }) => {
    const { t } = useTranslation();
    const [sortedData, setSortedData] = useState<Pick<UploadedImage, 'id' | 'name' | 'src'>[]>([]);
    const [time, setTime] = useState(Date.now())
    const [files, setFiles] = useState([])
    const [open, setOpen] = useState(false);
    const isMobile = useIsMobile();
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const is992 = useBreakpoint(LayoutConst.screen.m);
    const additionalValidate = true;
    const validator = useUploadValidator(onlyJpgFormat, additionalValidate);
    const s = useScale();
  
    const fileRef = useRef();
  
    useEffect(() => {
      onChange(sortedData?.[0]?.id);
    }, [sortedData])
  
    const onUploadComplete = useCallback((uploadComplete: any) => {
      if (uploadComplete) {
        setFiles([])
      }
    }, [])
  
    const [uppy, data] = useUppyLoader(files, fileRef, onUploadComplete, time);

    const onRemoveImage = useCallback((id: string, name: string) => {
        // @ts-ignore
        if (fileRef?.current) {
            fileRef.current.value = ''
            uppy.removeFile(id);
        }
        setTime(Date.now())
        setTimeout(() => {
            setFiles([])
        }, 0)
        }, [files, fileRef, uppy])
      
        const onAddImage = useCallback(async (e: any, isChange?: boolean) => {
          const newFiles = Array.from(e.target.files) as TFile[];
      
          // @ts-ignore
          if (fileRef?.current) fileRef.current.value = ''
      
          setTime(Date.now());
      
          let multipleFilesCheckResult: any = []
          if (newFiles?.length > 0) {
            multipleFilesCheckResult = await Promise.all(
              newFiles.map(async (img: TFile) => {
                return await validator([img])
              })
            )
          }
          const allowed = await validator(files)
      
          if (!allowed || multipleFilesCheckResult?.includes(false)) {
            e.target.value = ''
            return
          }
          
          //@ts-ignore
          onRemoveImage(newFiles?.[0]?.id, newFiles?.[0]?.name)
          setTimeout(() => {
            // @ts-ignore
            setFiles(newFiles);
          }, 0)
        }, [files, fileRef])

    const imageUrl = useMemo(() => {
    if (!data?.length) return undefined;
    return `${data?.[0].src}`
    },[fileRef?.current, data])

      const custom = {
        customBackgroundColor: Colors.galBlack5,
        customBorderColor: 'transparent',
        customBorderColorHover: 'transparent',
        customTextColor: Colors.galBlack100,
        customPlaceholderColor: Colors.galBlack47,
      };
  
    useEffect(() => {
      setSortedData(data)
    }, [data])

    return (
      <GridRow isTeamEdit fullWidth mobileColumn>
        {/* {label && (
          <FormLabel isTeamEdit>
            {label}
            {required && (
              <LabelRedStar>*</LabelRedStar>
            )}
          </FormLabel>
        )} */}
        <CommonLabel 
          label={label}
          required={required}
        />
        <Content className="content-container" style={{ position: 'relative' }}>
          {/* {!sortedData?.length && !!files?.length && (
            <ListWrapper>
              <NegativeMarginContainer>
                {files.map((file) => <Loader/>)}
              </NegativeMarginContainer>
            </ListWrapper>
          )} */}
          {files?.length ? (
            <ImagePreviewSectionImage width={s(564)} height={s(792)} url={imageUrl ?? ''}>
                <ImagePreviewSectionHolder
                    {...custom}
                    widthMobile={"calc(100vw - 20px)"}
                    heightMobile={"calc((100vw - 20px) * 1.407)"}
                    width={s(564)}
                    height={s(792)}
                              >
                        <input
                            type='file'
                            accept='image/jpeg, image/gif, image/png'
                            /*@ts-ignore*/
                            ref={fileRef}
                            onChange={(e) => {
                                onAddImage(e, true)
                            }}
                        />
                <ImagePreviewSectionPlacerButton
                    style={{ height:  40 + "px" }}
                >
                    {is992 ? '' : t('change_image')}
                </ImagePreviewSectionPlacerButton>
                </ImagePreviewSectionHolder>
            </ImagePreviewSectionImage>
          ) : (
                <ImagePreviewSectionHolder
                {...custom}
                widthMobile={"calc(100vw - 20px)"}
                heightMobile={"calc((100vw - 20px) * 1.407)"}
                width={s(564)}
                height={s(792)}
            >
                <div style={{ 
                    position: 'relative', 
                    height: '100%', 
                    width: '100%', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    placeItems: 'center' 
                }}>
                    <input
                        type='file'
                        accept='image/jpeg, image/gif, image/png'
                        /*@ts-ignore*/
                        ref={fileRef}
                        onChange={(e) => {
                            onAddImage(e)
                        }}
                    />
                    {isMobile && (
                      <FlexBox direction="column" directionMobile="column">
                        <FlexBox direction="column" directionMobile="column">
                            <LoadTitle>{'Загрузить обложку'}</LoadTitle>
                            {t('project_edit.image.text')}
                            <br/>
                            {t('project_edit.image.optimal', { height: 1600, width: 1140 })}
                        </FlexBox>
                        <PreformattedText>
                          {t('project_edit.image.text_mobile')}
                        </PreformattedText>
                      </FlexBox>
)}
                </div>
            </ImagePreviewSectionHolder>
          )}

        </Content>
      </GridRow>
    );
  }import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { GridRow, LoadTitle } from "../styles";
import { FormLabel } from "shared/modals/styles";
import { LabelRedStar } from "shared/pages/designerEditView/styles";
import styled from "styled-components";
import { ImagePreviewSectionHolder, ImagePreviewSectionImage, ImagePreviewSectionPlacerButton } from "shared/components/ImagePreviewSection/ImagePreviewSection";
import { Colors, CommonLabel, FlexBox, useBreakpoint, useIsMobile, useScale } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { TFile } from "@brg/api";
import { useUppyLoader, UploadedImage } from "shared/hooks/useUppyLoader";
import useUploadValidator from "shared/hooks/useUploadValidator";
import { LayoutConst } from "core";

const PreformattedText = styled(FlexBox)`
  white-space: break-spaces;
`

const Content = styled.div`
  width: 100%;
  min-height: 594px;

  input {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
    display: block !important;
    min-height: 564px !important;
  }

`


  interface ImageArrayUploadFieldProps {
    label: string;
    required?: boolean;
    onlyJpgFormat?: boolean;
  }
  
  export const CoverField: FC<ImageArrayUploadFieldProps> = ({
    input: { onChange, value: inputValue },
    meta: { touched, error },
    label,
    required,
    onlyJpgFormat,
    ...rest
  }) => {
    const { t } = useTranslation();
    const [sortedData, setSortedData] = useState<Pick<UploadedImage, 'id' | 'name' | 'src'>[]>([]);
    const [time, setTime] = useState(Date.now())
    const [files, setFiles] = useState([])
    const [open, setOpen] = useState(false);
    const isMobile = useIsMobile();
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const is992 = useBreakpoint(LayoutConst.screen.m);
    const additionalValidate = true;
    const validator = useUploadValidator(onlyJpgFormat, additionalValidate);
    const s = useScale();
  
    const fileRef = useRef();
  
    useEffect(() => {
      onChange(sortedData?.[0]?.id);
    }, [sortedData])
  
    const onUploadComplete = useCallback((uploadComplete: any) => {
      if (uploadComplete) {
        setFiles([])
      }
    }, [])
  
    const [uppy, data] = useUppyLoader(files, fileRef, onUploadComplete, time);

    const onRemoveImage = useCallback((id: string, name: string) => {
        // @ts-ignore
        if (fileRef?.current) {
            fileRef.current.value = ''
            uppy.removeFile(id);
        }
        setTime(Date.now())
        setTimeout(() => {
            setFiles([])
        }, 0)
        }, [files, fileRef, uppy])
      
        const onAddImage = useCallback(async (e: any, isChange?: boolean) => {
          const newFiles = Array.from(e.target.files) as TFile[];
      
          // @ts-ignore
          if (fileRef?.current) fileRef.current.value = ''
      
          setTime(Date.now());
      
          let multipleFilesCheckResult: any = []
          if (newFiles?.length > 0) {
            multipleFilesCheckResult = await Promise.all(
              newFiles.map(async (img: TFile) => {
                return await validator([img])
              })
            )
          }
          const allowed = await validator(files)
      
          if (!allowed || multipleFilesCheckResult?.includes(false)) {
            e.target.value = ''
            return
          }
          
          //@ts-ignore
          onRemoveImage(newFiles?.[0]?.id, newFiles?.[0]?.name)
          setTimeout(() => {
            // @ts-ignore
            setFiles(newFiles);
          }, 0)
        }, [files, fileRef])

    const imageUrl = useMemo(() => {
    if (!data?.length) return undefined;
    return `${data?.[0].src}`
    },[fileRef?.current, data])

      const custom = {
        customBackgroundColor: Colors.galBlack5,
        customBorderColor: 'transparent',
        customBorderColorHover: 'transparent',
        customTextColor: Colors.galBlack100,
        customPlaceholderColor: Colors.galBlack47,
      };
  
    useEffect(() => {
      setSortedData(data)
    }, [data])

    return (
      <GridRow isTeamEdit fullWidth mobileColumn>
        {/* {label && (
          <FormLabel isTeamEdit>
            {label}
            {required && (
              <LabelRedStar>*</LabelRedStar>
            )}
          </FormLabel>
        )} */}
        <CommonLabel 
          label={label}
          required={required}
        />
        <Content className="content-container" style={{ position: 'relative' }}>
          {/* {!sortedData?.length && !!files?.length && (
            <ListWrapper>
              <NegativeMarginContainer>
                {files.map((file) => <Loader/>)}
              </NegativeMarginContainer>
            </ListWrapper>
          )} */}
          {files?.length ? (
            <ImagePreviewSectionImage width={s(564)} height={s(792)} url={imageUrl ?? ''}>
                <ImagePreviewSectionHolder
                    {...custom}
                    widthMobile={"calc(100vw - 20px)"}
                    heightMobile={"calc((100vw - 20px) * 1.407)"}
                    width={s(564)}
                    height={s(792)}
                              >
                        <input
                            type='file'
                            accept='image/jpeg, image/gif, image/png'
                            /*@ts-ignore*/
                            ref={fileRef}
                            onChange={(e) => {
                                onAddImage(e, true)
                            }}
                        />
                <ImagePreviewSectionPlacerButton
                    style={{ height:  40 + "px" }}
                >
                    {is992 ? '' : t('change_image')}
                </ImagePreviewSectionPlacerButton>
                </ImagePreviewSectionHolder>
            </ImagePreviewSectionImage>
          ) : (
                <ImagePreviewSectionHolder
                {...custom}
                widthMobile={"calc(100vw - 20px)"}
                heightMobile={"calc((100vw - 20px) * 1.407)"}
                width={s(564)}
                height={s(792)}
            >
                <div style={{ 
                    position: 'relative', 
                    height: '100%', 
                    width: '100%', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    placeItems: 'center' 
                }}>
                    <input
                        type='file'
                        accept='image/jpeg, image/gif, image/png'
                        /*@ts-ignore*/
                        ref={fileRef}
                        onChange={(e) => {
                            onAddImage(e)
                        }}
                    />
                    {isMobile && (
                      <FlexBox direction="column" directionMobile="column">
                        <FlexBox direction="column" directionMobile="column">
                            <LoadTitle>{'Загрузить обложку'}</LoadTitle>
                            {t('project_edit.image.text')}
                            <br/>
                            {t('project_edit.image.optimal', { height: 1600, width: 1140 })}
                        </FlexBox>
                        <PreformattedText>
                          {t('project_edit.image.text_mobile')}
                        </PreformattedText>
                      </FlexBox>
)}
                </div>
            </ImagePreviewSectionHolder>
          )}

        </Content>
      </GridRow>
    );
  }